import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTimesCircle,
  faClock,
  faPercentage,
  faSortAmountDown,
  faSortAlphaDown,
  faChartBar,
  faCodeBranch,
  faGlobeAmericas,
  faIndustry,
  faHashtag,
  faBox,
  faBoxes
} from "@fortawesome/free-solid-svg-icons";
import { generateIcon, generateSpanText } from "./utilities.js";

library.add(
  faTimesCircle,
  faClock,
  faPercentage,
  faSortAmountDown,
  faSortAlphaDown,
  faChartBar,
  faCodeBranch,
  faGlobeAmericas,
  faIndustry,
  faHashtag,
  faBox,
  faBoxes
);

// generate visual grouping
function generateInputGroup() {
  let divElement = document.createElement("div");
  divElement.className = "input-group mb-1 btn-group-vertical";
  return divElement;
}

// generate header
function generateCardHeader(text) {
  let cardElement = document.createElement("div");
  cardElement.className = "card-header font-bold text-center census-font";
  cardElement.innerHTML = text;
  return cardElement;
}

function generateDropdownButton(id, text) {
  let buttonElement = document.createElement("button");
  buttonElement.className =
    "btn btn-outline-secondary dropdown-toggle btn-block custom-dropdown census-font";
  buttonElement.id = id;
  buttonElement.type = "button";
  buttonElement.title = text;
  buttonElement.setAttribute("aria-haspopup", "true");
  buttonElement.setAttribute("aria-expanded", "false");
  buttonElement.setAttribute("data-display", "static");
  buttonElement.setAttribute("data-toggle", "dropdown");
  buttonElement.innerHTML = text;
  return buttonElement;
}

function generateDropdownDiv(id, labeledby) {
  let divElement = document.createElement("div");
  divElement.id = id;
  divElement.className = "dropdown-menu";
  divElement.setAttribute("aria-labelledby", labeledby);

  // add searchable form
  let dropdownMenuForm = document.createElement("form");
  dropdownMenuForm.className = "px-4 py-2";
  let dropdownMenuSearch = document.createElement("input");
  dropdownMenuSearch.type = "search";
  dropdownMenuSearch.setAttribute("placeholder", "Search...");
  dropdownMenuSearch.setAttribute("autocomplete", "off");
  dropdownMenuSearch.setAttribute("onkeydown", "return event.key != 'Enter';");
  dropdownMenuSearch.className =
    "form-control dropdown-search form-control-sm census-font";
  dropdownMenuSearch.addEventListener("input", function() {
    searchFilter(this.value.trim().toLowerCase(), id);
  });
  dropdownMenuForm.appendChild(dropdownMenuSearch);
  divElement.appendChild(dropdownMenuForm);

  let dropdownMenuList = document.createElement("div");
  dropdownMenuList.className = "dropdown-list census-font";
  divElement.appendChild(dropdownMenuList);

  return divElement;
}

function searchFilter(input, id) {
  // hide all elements that don't contain the text
  let displayed = $j33(`#${id} > .dropdown-list > a`)
    .css("display", "none")
    .filter(function() {
      return (
        $j33(this)
          .text()
          .toLowerCase()
          .indexOf(input) > -1 && $j33(this).attr("id") !== "nodata"
      );
    })
    .css("display", "block").length;

  let nodataElement = $j33(`#${id} > .dropdown-list > a#nodata`);
  displayed === 0
    ? nodataElement.css("display", "block")
    : nodataElement.css("display", "none");
}

function generateToggleLabel(id, title) {
  let labelElement = document.createElement("label");
  labelElement.id = id;
  labelElement.title = title;
  return labelElement;
}

function generateTwotoggleLabel(element) {
  element.className = "btn btn-outline-secondary w-100 btn-icon-left census-font";
  return element;
}

function generateThreetoggleLabel(element) {
  element.className = "btn btn-outline-secondary w-100 census-font";
  return element;
}

function generateToggleRadio(id, name) {
  let inputElement = document.createElement("input");
  inputElement.type = "radio";
  inputElement.id = id;
  inputElement.name = name;
  return inputElement;
}

function generateButton(id, name) {
  let buttonElement = document.createElement("button");
  buttonElement.type = "button";
  buttonElement.id = id;
  buttonElement.name = name;
  buttonElement.className = "btn btn-outline-secondary w-100 census-font";
  return buttonElement;
}

function generateToggleDiv(id) {
  let toggleDiv = document.createElement("div");
  toggleDiv.className = "btn-group btn-group-toggle w-100";
  toggleDiv.setAttribute("data-toggle", "buttons");
  toggleDiv.id = id;
  return toggleDiv;
}

// control panel buttons
let ctrlDiv = document.getElementById("controlpanel");

// data type options
let dataToggleDiv = generateInputGroup();
dataToggleDiv.appendChild(generateCardHeader("Data Type"));

let dataToggleBtnGrp = generateToggleDiv("data-type-toggle");

let earningsLabel = generateTwotoggleLabel(
  generateToggleLabel("earnings-label", "Earnings")
);
let earningsRadio = generateToggleRadio("earnings-radio", "");
earningsLabel.appendChild(earningsRadio);
dataToggleBtnGrp.appendChild(earningsLabel);

let flowsLabel = generateTwotoggleLabel(
  generateToggleLabel("flows-label", "Flows")
);
let flowsRadio = generateToggleRadio("flows-radio", "");
flowsRadio.checked = false;
flowsLabel.appendChild(flowsRadio);
dataToggleBtnGrp.appendChild(flowsLabel);
dataToggleDiv.appendChild(dataToggleBtnGrp);

ctrlDiv.appendChild(dataToggleDiv);

// earnings icon
let earningsIcon = generateIcon("chart-bar");
earningsIcon.className += "icon-toggle-inactive"
earningsLabel.appendChild(earningsIcon);
earningsLabel.appendChild(generateSpanText(" Earnings"));

// flows icon
let flowsIcon = generateIcon("code-branch");
flowsIcon.className += "icon-toggle-inactive fa-rotate-90";
flowsLabel.appendChild(flowsIcon);
flowsLabel.appendChild(generateSpanText(" Flows"));

// state dropdown
let stateDiv = generateInputGroup();
stateDiv.appendChild(generateCardHeader("State"));
stateDiv.appendChild(
  generateDropdownButton("state-dropdown-button", "Select State")
);
let stateDropdown = generateDropdownDiv("state-dropdown", "state-dropdown-button")
stateDropdown.className += " scrollable-menu";
stateDiv.appendChild(stateDropdown);
ctrlDiv.appendChild(stateDiv);

// university dropdown
let univDiv = generateInputGroup();
univDiv.appendChild(generateCardHeader("Institution"));
univDiv.appendChild(
  generateDropdownButton("institution-dropdown-button", "Select Institution")
);
let institutionDropdown = generateDropdownDiv(
  "institution-dropdown",
  "institution-dropdown-button"
);
institutionDropdown.className += " scrollable-menu";
univDiv.appendChild(institutionDropdown);
ctrlDiv.appendChild(univDiv);

// deglevel dropdown
let deglevDiv = generateInputGroup();
deglevDiv.appendChild(generateCardHeader("Degree Level"));
deglevDiv.appendChild(
  generateDropdownButton("degreelevel-dropdown-button", "Select Degree Level")
);
deglevDiv.appendChild(
  generateDropdownDiv("degreelevel-dropdown", "degreelevel-dropdown-button")
);
ctrlDiv.appendChild(deglevDiv);

// deglevel dropdown
let cohortDiv = generateInputGroup();
cohortDiv.appendChild(generateCardHeader("Graduation Cohort"));
cohortDiv.appendChild(
  generateDropdownButton("gradcohort-dropdown-button", "Select Cohort")
);
cohortDiv.appendChild(
  generateDropdownDiv("gradcohort-dropdown", "gradcohort-dropdown-button")
);
ctrlDiv.appendChild(cohortDiv);

// postgrad v percentile swap
let twotoggleDiv = generateInputGroup();
twotoggleDiv.appendChild(generateCardHeader("Compare Earnings by"));
let twotoggleBtnGrp = generateToggleDiv("twotoggle");
let clockLabel = generateTwotoggleLabel(
  generateToggleLabel("clock-button", "Compare by Years Postgrad")
);
let clockRadio = generateToggleRadio("earnings-percentile", "radioName");
clockLabel.className += " active";
clockRadio.checked = true;
clockLabel.appendChild(clockRadio);
twotoggleBtnGrp.appendChild(clockLabel);
let percentLabel = generateTwotoggleLabel(
  generateToggleLabel("percent-button", "Compare by Earnings Percentile")
);
let percentRadio = generateToggleRadio("years-postgrad", "radioName");
percentRadio.checked = false;
percentLabel.appendChild(percentRadio);
twotoggleBtnGrp.appendChild(percentLabel);
twotoggleDiv.appendChild(twotoggleBtnGrp);
ctrlDiv.appendChild(twotoggleDiv);

// flows Data Toggle
let flowstoggleDiv = generateInputGroup();
flowstoggleDiv.appendChild(generateCardHeader("Destination Flows"));
let flowstoggleBtnGrp = generateToggleDiv("flowstoggle");
let naicsButton = generateButton("industry-button", "industry-button");
naicsButton.title = "Flows to NAICS Industry Sector";
let naicsIcon = generateIcon("industry");
naicsIcon.className += "icon-toggle-active";
naicsButton.appendChild(naicsIcon);
naicsButton.appendChild(generateSpanText(" Industry"));

flowstoggleBtnGrp.appendChild(naicsButton);

let geographyButton = generateButton("geography-button", "geography-button");
geographyButton.title = "Flows to State/Census Division";
let geographyIcon = generateIcon("globe-americas");
geographyIcon.className += "icon-toggle-inactive";
geographyButton.appendChild(geographyIcon);
geographyButton.appendChild(generateSpanText(" Geo"));

flowstoggleBtnGrp.appendChild(geographyButton);
flowstoggleDiv.appendChild(flowstoggleBtnGrp);
ctrlDiv.appendChild(flowstoggleDiv);

// three toggle radio button
let threetoggleContainerDiv = generateInputGroup();
let threetoggleCardHeader = generateCardHeader("");
threetoggleCardHeader.id = "radioLabel";
threetoggleContainerDiv.appendChild(threetoggleCardHeader);
let threetoggleDiv = generateToggleDiv("threetoggle");
let label1 = generateThreetoggleLabel(generateToggleLabel("Select Options"));
label1.appendChild(generateToggleRadio("radioselect1", "radioSelect"));
label1.appendChild(document.createElement("span"));
threetoggleDiv.appendChild(label1);
let label2 = generateThreetoggleLabel(generateToggleLabel("Select Options"));
label2.appendChild(generateToggleRadio("radioselect2", "radioSelect"));
label2.appendChild(document.createElement("span"));
threetoggleDiv.appendChild(label2);
let label3 = generateThreetoggleLabel(generateToggleLabel("Select Options"));
label3.appendChild(generateToggleRadio("radioselect3", "radioSelect"));
label3.appendChild(document.createElement("span"));
threetoggleDiv.appendChild(label3);
threetoggleContainerDiv.appendChild(threetoggleDiv);
ctrlDiv.appendChild(threetoggleContainerDiv);


// Flows selected cut
let flowsCutDiv = generateInputGroup();
flowsCutDiv.appendChild(generateCardHeader("Years-postgrad Filter"));
let flowsCutBtnGrp = generateToggleDiv("flows-selected-cut");

let oneYearPostgradLabel = generateTwotoggleLabel(
  generateToggleLabel("one-button", "Filter by 1 Year Postgrad")
);
let oneYearPostgradRadio = generateToggleRadio(
  "1-yearpostgrad",
  "1-yearpostgrad"
);
oneYearPostgradRadio.checked = false;
oneYearPostgradLabel.appendChild(oneYearPostgradRadio);
let oneYearPostgradSpan = document.createElement("span");
oneYearPostgradSpan.innerHTML = "1";
oneYearPostgradLabel.appendChild(oneYearPostgradSpan);
flowsCutBtnGrp.appendChild(oneYearPostgradLabel);

let fiveYearsPostgradLabel = generateTwotoggleLabel(
  generateToggleLabel("five-button", "Filter by 5 Year Postgrad")
);
let fiveYearsPostgradRadio = generateToggleRadio(
  "5-yearspostgrad",
  "5-yearspostgrad"
);
fiveYearsPostgradLabel.className += " active";
fiveYearsPostgradRadio.checked = true;
fiveYearsPostgradLabel.appendChild(fiveYearsPostgradRadio);
let fiveYearsPostgradSpan = document.createElement("span");
fiveYearsPostgradSpan.innerHTML = "5";
fiveYearsPostgradLabel.appendChild(fiveYearsPostgradSpan);
flowsCutBtnGrp.appendChild(fiveYearsPostgradLabel);

let tenYearsPostgradLabel = generateTwotoggleLabel(
  generateToggleLabel("five-button", "Filter by 10 Year Postgrad")
);
let tenYearsPostgradRadio = generateToggleRadio(
  "10-yearspostgrad",
  "10-yearspostgrad"
);
tenYearsPostgradRadio.checked = false;
tenYearsPostgradLabel.appendChild(tenYearsPostgradRadio);
let tenYearsPostgradSpan = document.createElement("span");
tenYearsPostgradSpan.innerHTML = "10";
tenYearsPostgradLabel.appendChild(tenYearsPostgradSpan);
flowsCutBtnGrp.appendChild(tenYearsPostgradLabel);
flowsCutDiv.appendChild(flowsCutBtnGrp);
ctrlDiv.appendChild(flowsCutDiv);

// flows display Toggle
let flowsDisplayDiv = generateInputGroup();
flowsDisplayDiv.appendChild(generateCardHeader("Display"));
let flowsDisplayBtnGrp = generateToggleDiv("flows-display");
let countButton = generateButton("count-button", "count-button");
countButton.title = "Display Flows by Count";
countButton.className += " active";

let countIcon = generateIcon("hashtag");
countIcon.className += "icon-toggle-active";
countButton.appendChild(countIcon);
flowsDisplayBtnGrp.appendChild(countButton);
countButton.appendChild(generateSpanText(" Count"));

let shareButton = generateButton("share-button", "share-button");
shareButton.title = "Display Flows as Share of Total";
let shareIcon = generateIcon("percentage");
shareIcon.className += "icon-toggle-inactive";
shareButton.appendChild(shareIcon);
shareButton.appendChild(generateSpanText(" Share"));

flowsDisplayBtnGrp.appendChild(shareButton);
flowsDisplayDiv.appendChild(flowsDisplayBtnGrp);
ctrlDiv.appendChild(flowsDisplayDiv);

// clock and percent icon
let clockButton = document.getElementById("clock-button");
let clockIcon = generateIcon("clock");
clockIcon.className += "icon-toggle-active";
clockButton.appendChild(clockIcon);
clockButton.appendChild(generateSpanText(" Time"));
let percentButton = document.getElementById("percent-button");
let percentIcon = generateIcon("percentage");
percentIcon.className += "icon-toggle-inactive";
percentButton.appendChild(percentIcon);
percentButton.appendChild(generateSpanText(" Percent"));

// legend
let legendContainerDiv = generateInputGroup();
legendContainerDiv.appendChild(generateCardHeader("Legend"));
let legendDiv = document.createElement("div");
legendDiv.id = "legend";
legendDiv.className = "border border-secondary rounded-bottom";
legendContainerDiv.appendChild(legendDiv);
ctrlDiv.appendChild(legendContainerDiv);

// bottom left ctrl panel
let secondaryCtrlDiv = document.getElementById("secondarycontrolpanel");


// cip level toggle - 2 or 4 digit
let cipLevelToggleDiv = generateInputGroup();
let cipLevelCardHeader = generateCardHeader("Program Specificity");
cipLevelToggleDiv.appendChild(cipLevelCardHeader);
let cipLevelToggleBtnGrp = generateToggleDiv("cip-level-toggle");


// first button and label for 2 digit cips
let twoDigitCipLabel= generateTwotoggleLabel(
    generateToggleLabel(
        "two-digit-cip-label",
        "Show General Degree Categories (2-digit CIP Codes)"
    )
);
let twoDigitCipRadio = generateToggleRadio("two-digit-cip-toggle", "");
twoDigitCipLabel.className += " active";
twoDigitCipRadio.checked = true;
twoDigitCipLabel.appendChild(twoDigitCipRadio);
cipLevelToggleBtnGrp.appendChild(twoDigitCipLabel);

let fourDigitCipLabel = generateTwotoggleLabel(
    generateToggleLabel(
        "four-digit-cip-label",
        "Show Detailed Degree Categories (4-digit CIP Codes)"
    )
);
let fourDigitCipRadio = generateToggleRadio("four-digit-cip-toggle", "");

fourDigitCipRadio.checked = false;
fourDigitCipLabel.appendChild(fourDigitCipRadio);
cipLevelToggleBtnGrp.appendChild(fourDigitCipLabel);

cipLevelToggleDiv.appendChild(cipLevelToggleBtnGrp);
secondaryCtrlDiv.appendChild(cipLevelToggleDiv);

let twoDigitCipIcon = generateIcon("box");
twoDigitCipIcon.className += "icon-toggle-active";
twoDigitCipLabel.appendChild(twoDigitCipIcon);
twoDigitCipLabel.appendChild(generateSpanText(" General"));


let fourDigitCipIcon = generateIcon("boxes");
fourDigitCipIcon.className += "icon-toggle-inactive";
fourDigitCipLabel.appendChild(fourDigitCipIcon);
fourDigitCipLabel.appendChild(generateSpanText(" Detailed"));

// degree ordering toggle
let sortOrderToggleDiv = generateInputGroup();
let sortOrderCardHeader = generateCardHeader("Sort Program List by");
sortOrderToggleDiv.appendChild(sortOrderCardHeader);
let sortOrderToggleBtnGrp = generateToggleDiv("sort-order-toggle");

let cellcountLabel = generateTwotoggleLabel(
  generateToggleLabel(
    "cellcount-order-label",
    "Order by Program Size (Count of Program Completers)"
  )
);
let cellcountRadio = generateToggleRadio("cellcount-order", "");
cellcountLabel.className += " active";
cellcountRadio.checked = true;
cellcountLabel.appendChild(cellcountRadio);
sortOrderToggleBtnGrp.appendChild(cellcountLabel);

let alphaLabel = generateTwotoggleLabel(
  generateToggleLabel(
    "alpha-order-label",
    "Order by Program Name Alphabetically"
  )
);
let alphaRadio = generateToggleRadio("alpha-order", "");
alphaRadio.checked = false;
alphaLabel.appendChild(alphaRadio);

sortOrderToggleBtnGrp.appendChild(alphaLabel);
sortOrderToggleDiv.appendChild(sortOrderToggleBtnGrp);
secondaryCtrlDiv.appendChild(sortOrderToggleDiv);

// cellcount ordering icon
let countOrderIcon = generateIcon("sort-amount-down");
countOrderIcon.className += "icon-toggle-inactive";
cellcountLabel.appendChild(countOrderIcon);
cellcountLabel.appendChild(generateSpanText(" Size"));


// alpha ordering icon
let alphaOrderIcon = generateIcon("sort-alpha-down");
alphaOrderIcon.className += "icon-toggle-inactive";
alphaLabel.appendChild(alphaOrderIcon);
alphaLabel.appendChild(generateSpanText(" Name"));

//clear selection button
let clearInputGroup = generateInputGroup();
let clearButton = generateButton("clearbutton", "clear-button")
clearInputGroup.appendChild(clearButton);
secondaryCtrlDiv.appendChild(clearInputGroup);

// double arrow icon
let clearIcon = generateIcon("times-circle");
clearIcon.className += "icon-toggle-inactive";
clearButton.appendChild(clearIcon);
clearButton.appendChild(generateSpanText(" Clear Selected"));

function degreeSearchFilter(input) {
  // hide all elements that don't contain the text
  $j33(`#checkbox-grid > label`)
      .css("display", "none")
      .filter(function() {
        return (
            $j33(this)
                .children(".label")
                .text()
                .toLowerCase()
                .indexOf(input) > -1
        );
      })
      .css("display", "inline-block");
}
// degree search input
let degreeSearchForm = document.createElement("form");
degreeSearchForm.className = "mb-1 mt-1";
let degreeSearch = document.createElement("input");
degreeSearch.id = "degree-search";
degreeSearch.type = "search";
degreeSearch.setAttribute("placeholder", "Filter Degrees...");
degreeSearch.setAttribute("autocomplete", "off");
degreeSearch.setAttribute("onkeydown", "return event.key != 'Enter';");
degreeSearch.className =
    "form-control dropdown-search form-control-sm census-font";
degreeSearch.addEventListener("input", function() {
  degreeSearchFilter(this.value.trim().toLowerCase());
});
degreeSearchForm.appendChild(degreeSearch);
secondaryCtrlDiv.appendChild(degreeSearchForm);


